export default "__VITE_PUBLIC_ASSET__1b872c4c__"